import { Button } from '@/components/ui/button'
import { CheckCircle2, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

export default function BuyerIntakeConfirmation() {
  const navigate = useNavigate()

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="text-center space-y-6 py-8"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
      >
        <CheckCircle2 className="h-16 w-16 text-primary mx-auto" />
      </motion.div>

      <div className="space-y-3">
        <h2 className="text-2xl font-bold text-foreground">
          Your Match Profile Is Live
        </h2>
        <p className="text-muted-foreground text-sm max-w-md mx-auto leading-relaxed">
          We'll only send businesses that fall within your selected criteria.
          If your scope changes, update your profile at any time.
        </p>
      </div>

      <Button
        onClick={() => navigate('/dashboard')}
        size="lg"
        variant="hero"
        className="gap-2"
      >
        Go to My Dashboard <ArrowRight className="h-4 w-4" />
      </Button>
    </motion.div>
  )
}
